// extracted by mini-css-extract-plugin
export default {"custom_img":"Hero_custom_img__yCE0u","custom_video":"Hero_custom_video__Gndy+","custom_caption":"Hero_custom_caption__R+538","carousel-item":"Hero_carousel-item__JWMgv"};